import { useParams } from "react-router-dom";
import { useGetQuizQuery } from "../../../../features/quiz/quizApi";
import EmptyResult from "../../../ui/EmptyResult";
import Error from "../../../ui/Error";
import Loading from "../../../ui/Loading";
import EditQuizForm from "./EditQuizForm";

export default function EditQuiz() {
	const { quizId } = useParams();
	const {
		data: quiz,
		isLoading,
		isError,
	} = useGetQuizQuery(quizId) || {};

    // Decide what to render
    let content = null;
    if (isLoading) {
        content = <Loading />;
    }
    else if (!isLoading && isError) {
        content = <Error message="There was an error!" />;
    }
    else if (!isLoading && !isError && quiz === undefined) {
        content = <EmptyResult message="Sorry the assignment is not found!" />;
    }
    else if (!isLoading && !isError && quiz !== undefined) {
        content = <EditQuizForm quiz={quiz} />
    }

	return (
        <section className="py-6 bg-primary place-items-center">
			<div className="mx-auto max-w-5xl px-5 lg:px-0">
				{content}
			</div>
		</section>
    );
}
